// src/parts/Home.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css/effect-fade"; // Re-add necessary Swiper CSS

// Import Swiper styles
import "swiper/css";
import "aos/dist/aos.css";

// Import images (reusing the ones for specials/events)
import img1 from "../assets/slides/WhatsApp Image 2025-10-03 at 07.09.14 (1).jpeg";
import img2 from "../assets/slides/WhatsApp Image 2025-10-03 at 07.09.14.jpeg";
import img3 from "../assets/slides/WhatsApp Image 2025-10-03 at 07.09.15.jpeg";
import img4 from "../assets/slides/WhatsApp Image 2025-10-03 at 07.09.17 (1).jpeg";
import img5 from "../assets/slides/WhatsApp Image 2025-10-03 at 07.09.19.jpeg";
import img6 from "../assets/slides/WhatsApp Image 2025-10-08 at 15.08.31.jpeg";

const Home = () => {
  const slidesData = [
    {
      image: img1,
      title: "Savor the Flavor",
      description: "Every dish is a masterpiece, crafted with passion and the finest ingredients.",
    },
    {
      image: img2,
      title: "Dine in Style",
      description: "Experience our warm and inviting ambiance, perfect for any occasion.",
    },
    {
      image: img3,
      title: "Unforgettable Events",
      description: "Let us make your special moments even more memorable with our expert catering.",
    },
    {
      image: img4,
      title: "A Feast for the Senses",
      description: "Explore a world of culinary delights with our diverse and exciting menu.",
    },
    {
      image: img5,
      title: "Service with a Smile",
      description: "Our friendly team is dedicated to providing you with an exceptional dining experience.",
    },
    {
      image: img6,
      title: "Deliciousness Delivered",
      description: "Enjoy your favorite meals from Honex Food Center at home.",
    },
  ];

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlideIndex((prevIndex) =>
        prevIndex === slidesData.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [slidesData.length]);

  const currentSlide = slidesData[currentSlideIndex];

  // Reduced and dynamic Welcome Banner
  return (
    <section id="home" className="bg-gradient-to-b from-[#f8fafc] to-[#fff] min-h-screen">
      <div className="relative w-full h-[calc(100vh-4rem)] overflow-hidden">
        {/* Welcome Banner - now smaller, dynamic, and above slide content */}
        <div className="absolute left-0 right-0 top-16 z-20 flex justify-center pt-8 pointer-events-none">
          <div className="bg-white/80 rounded-xl shadow-lg px-6 py-3 text-center border border-[#d99e37] max-w-xs">
            <h4 className="text-lg font-bold text-[#5b3006]">
              Welcome To <br />
              <span className="text-[#d99e37]">HONEX FOOD CENTER</span>
            </h4>
          </div>
        </div>
        {/* Slide */}}
        <div className="absolute inset-0 z-0 transition-opacity duration-1000 ease-in-out h-full">
          <img
            src={currentSlide.image}
            alt={currentSlide.title}
            className="w-full h-full object-cover scale-105 blur-[1px] brightness-90"
            style={{ maxHeight: "100%", height: "100vh" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-transparent flex flex-col justify-center items-center text-center p-4">
            <h2 className="text-white text-4xl md:text-6xl font-extrabold mb-4 drop-shadow-lg animate-fade-in" data-aos="fade-up">
              {currentSlide.title}
            </h2>
            <p className="text-white text-lg md:text-2xl font-medium mb-6 animate-fade-in" data-aos="fade-up" data-aos-delay="200">
              {currentSlide.description}
            </p>
            <div className="flex gap-4 mt-4">
              {/* <a
                href="/menu"
                className="px-6 py-2 rounded-full shadow-lg font-semibold transition
                  bg-white text-[#5b3006]
                  border-2 border-[#d99e37]
                  hover:bg-[#d99e37] hover:text-white hover:border-[#5b3006]"
              >
                Explore Menu
              </a> */}
              <a
                href="/contact"
                className="px-6 py-2 rounded-full shadow-lg font-semibold transition
                  bg-gradient-to-r from-[#d99e37] to-[#5b3006] text-white
                  border-2 border-[#5b3006]
                  hover:from-[#5b3006] hover:to-[#d99e37] hover:border-[#d99e37] hover:text-[#fff]"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
        {/* Pagination Dots */}
        <div className="absolute left-0 right-0 bottom-10 md:bottom-6 z-20 flex justify-center pb-8">
          <div className="flex space-x-3">
            {slidesData.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlideIndex(index)}
                className={`w-4 h-4 rounded-full border-2 ${
                  currentSlideIndex === index
                    ? "bg-[#d99e37] border-[#5b3006] scale-110 shadow-lg"
                    : "bg-white border-[#d99e37] opacity-60"
                } hover:scale-110 transition-all`}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="max-w-6xl mx-auto py-20 px-4 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        {[
          {
            icon: (
              <svg className="w-10 h-10 text-[#5b3006]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 6h16M4 10h16M4 14h16M4 18h16"/></svg>
            ),
            title: "Restaurant Dining",
            desc: "Enjoy a variety of delicious meals in our cozy restaurant.",
          },
          {
            icon: (
              <svg className="w-10 h-10 text-[#5b3006]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            ),
            title: "Catering & Events",
            desc: "Professional catering for weddings, parties, and corporate events.",
          },
          {
            icon: (
              <svg className="w-10 h-10 text-[#5b3006]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10a9 9 0 11-18 0 9 9 0 0118 0z"/><path d="M12 14v2m0-8v2m-4 4h8"/></svg>
            ),
            title: "Delivery Service",
            desc: "Get your favorite meals delivered to your doorstep.",
          },
          {
            icon: (
              <svg className="w-10 h-10 text-[#5b3006]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
            ),
            title: "Customer Support",
            desc: "Reach out for reservations, inquiries, or feedback.",
          },
        ].map((service, idx) => (
          <div key={idx} className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center hover:scale-105 transition-all border-t-4 border-[#d99e37]">
            <div className="mb-4">{service.icon}</div>
            <h3 className="text-2xl font-bold mb-2 text-[#5b3006]">{service.title}</h3>
            <p className="text-gray-600 mb-4">{service.desc}</p>
          </div>
        ))}
      </div>
      <div className="flex justify-center mb-12">
        <Link
          to="/services"
          className="text-[#d99e37] font-semibold hover:text-[#5b3006] transition"
          style={{ fontSize: "1.1rem" }}
        >
          View All Services &rarr;
        </Link>
      </div>

      {/* Gallery Section */}}
      <div className="max-w-6xl mx-auto pb-20 px-4">
        <div className="flex items-center justify-center mb-8 gap-4">
          <h2 className="text-3xl font-bold text-[#5b3006]">Gallery</h2>
        </div>
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          {[img1, img2, img3, img4, img5, img6].map((img, idx) => (
          <div key={idx} className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-all">
            <img src={img} alt={`Gallery ${idx + 1}`} className="w-full h-64 object-cover" />
          </div>
          ))}
        </div>
        {/* Inline "View More" link at the bottom of gallery section */}
        <div className="flex justify-center mt-10">
          <Link
            to="/gallery"
            className="text-[#d99e37] font-semibold hover:text-[#5b3006] transition"
            style={{ fontSize: "1.1rem" }}
          >
            View More &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Home;